import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import config from "../../config";
import { Helmet } from "react-helmet-async";
import Header from "../../Components/Common/Header";
import Footer from "../../Components/Common/Footer";
import "./StaticPage.css";

function StaticPage() {
  const { slug } = useParams();
  console.log(slug);
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await fetch(`${config.baseUrl}/static-page/${slug}`);
        const data = await res.json();
        setPageData(data.data);
      } catch (error) {
        console.error("Page not found", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  useEffect(() => {
    if (!pageData) return;

    // Initialize accordion after content is loaded
    const initAccordion = () => {
      const questions = document.querySelectorAll(".question");

      questions.forEach((question) => {
        // Add click handler
        question.addEventListener("click", () => {
          const answer = question.nextElementSibling;
          const item = question.parentElement;

          // Toggle active class
          item.classList.toggle("active");

          // Toggle answer visibility
          if (item.classList.contains("active")) {
            answer.style.maxHeight = answer.scrollHeight + "px";
          } else {
            answer.style.maxHeight = 0;
          }

          // Close other open items if needed
          document.querySelectorAll(".faq").forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("active")) {
              otherItem.classList.remove("active");
              otherItem.querySelector(".answer").style.maxHeight = 0;
            }
          });
        });
      });
    };

    // Use setTimeout to ensure DOM is ready
    setTimeout(initAccordion, 100);
  }, [pageData]);

  if (loading) return <div>Loading...</div>;
  if (!pageData) return <div>Page not found</div>;

  return (
    <div className="static-page">
      <Helmet>
        <title>{pageData.meta_title}</title>
        <meta name="description" content={`${pageData.meta_description}`} />
        <meta name="keywords" content={`${pageData.meta_keyword}`} />
      </Helmet>
      <Header />
      <div className="common-banenr">
        <div className="common-content">
          <h1>
            {pageData.title
              .split(" ")
              .slice(0, Math.floor(pageData.title.split(" ").length / 2))
              .join(" ")}
            <span>
              {" " +
                pageData.title
                  .split(" ")
                  .slice(Math.floor(pageData.title.split(" ").length / 2))
                  .join(" ")}
            </span>
          </h1>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
      <Footer />
    </div>
  );
}

export default StaticPage;
